import React  from "react";
import { useParams } from 'react-router-dom';
import AccessGroupUserForm from "./components/AccessGroupUserForm";

const EditAccessGroupUser = () => {
	const { rightId } = useParams();
    
	return (
	    <div>
	    	<div className="mt-5 grid h-full grid-cols-1 gap-4">
	      		<AccessGroupUserForm recordId={rightId} mode="edit"/>
	      </div>
	    </div>
    );
};

export default EditAccessGroupUser;